import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import CloseIcon from '@mui/icons-material/Close'
import ShutterSpeedIcon from '@mui/icons-material/ShutterSpeed'
import WifiTetheringOffIcon from '@mui/icons-material/WifiTetheringOff'
import '../../Style.css'
import {
  Backdrop,
  Box,
  Card,
  CardHeader,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  IconButton,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { id } from 'date-fns/locale'
import _, { reject } from 'lodash'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import * as Yup from 'yup'

import Button from '../../shared/Button'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import {
  getDevice,
  getError,
  getLoading,
  getMessage,
  getOnlyDevice,
  getOverSpeed,
  getOverSpeedAlarms,
  offOverSpeedLimitation,
  overSpeedAlarms,
  overSpeedLimitation,
  resetOverSpeedAlarms,
  setError,
  setMessage,
} from '../../store/devices'

import { resolve } from 'path'

interface FormValues {
  speed: string
}

const initialValues: FormValues = { speed: '' }

const validationSchema = Yup.object().shape({
  speed: Yup.string()
    .max(3, ' حداکثر 3 کارکتر مجاز می باشد')
    .required('ورود سرعت اجباری است')
    .label('speed')
    .matches(/^[1-9][0-9]*$/, 'لطفا میزان سرعت را به درستی وارد نمایید'),
})
const SecurityScreen = () => {
  const matches = useMediaQuery('(min-width:600px)')
  const rows = useSelector(getOverSpeedAlarms)
  const [open, setOpen] = useState(false)
  const loading = useSelector(getLoading)
  const { id } = useParams()
  const dispatch = useDispatch<Dispatch<any>>()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const error = useSelector(getError)
  const message = useSelector(getMessage)
  const deviceList = useSelector(getOnlyDevice)
  const OverSpeed = useSelector(getOverSpeed)
  const { t } = useTranslation()
  interface Column {
    id: 'id' | 'day' | 'dateTime' | 'runtimeSeconds' | 'speed'

    label: string
    minWidth?: number
    align?: 'center'
    format?: (value: number) => string
  }
  const columns: readonly Column[] = [
    {
      id: 'id',
      label: t('screens.SecurityScreen.id'),
      minWidth: matches ? 50 : 10,
      align: 'center',
    },
    {
      id: 'day',
      label: t('screens.SecurityScreen.day'),
      minWidth: matches ? 50 : 10,
      align: 'center',
    },
    {
      id: 'dateTime',
      label: t('screens.SecurityScreen.date'),
      minWidth: matches ? 50 : 10,
      align: 'center',
    },
    {
      id: 'runtimeSeconds',
      label: t('screens.SecurityScreen.duration'),
      minWidth: matches ? 50 : 10,
      align: 'center',
    },
    {
      id: 'speed',
      label: t('screens.SecurityScreen.speed'),
      minWidth: matches ? 50 : 10,
      align: 'center',
    },
  ]
  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }
  const shamsiDay = (time: any) => {
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.weekDay.name
  }

  const [open3, setOpen3] = useState(false)
  const [speed, setSpeed] = useState(deviceList)

  const handleCancelOpen = (e: any) => {
    setOpen3(false)
    dispatch(resetOverSpeedAlarms)
  }
  const handleCancel = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (id !== undefined) dispatch(getDevice(id))
  }, [])
  const [userSpeed, setUserSpeed] = useState(0)
  useEffect(() => {
    setSpeed({ overSpeedLimitation: userSpeed })
  }, [OverSpeed])

  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    setSpeed(deviceList)
  }, [deviceList])
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
  }, [message])
  const handleSubmit = (values: any) => {
    if (id !== undefined) dispatch(overSpeedLimitation({ imei: id, speed: values.speed }))
    setUserSpeed(values.speed)
    setOpen(false)
  }
  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          direction: 'ltr',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2 }}>
          <ArrowBackRoundedIcon
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: 'red',
              borderRadius: '50%',
              color: '#fff',

              cursor: 'pointer',
            }}
          />
          <img alt='Logo' src='/images/TinyLogo.png' />
        </Box>
        <Box sx={{ mb: 1, ml: 1 }}>
          <Fab
            aria-label='add'
            color='primary'
            onClick={() => {
              setOpen(true)
            }}
            size='medium'
            sx={{ margin: '8px 0', width: '100%' }}
            variant='extended'
          >
            {t('screens.SecurityScreen.Create_a_new_speed_limiter')}
          </Fab>
        </Box>
        <div>
          <Dialog
            aria-describedby='alert-dialog-description'
            aria-labelledby='alert-dialog-title'
            open={open}
          >
            <DialogTitle
              id='alert-dialog-title'
              sx={{
                direction: 'rtl',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {t('screens.SecurityScreen.speed_limit')}
              <IconButton onClick={handleCancel}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Box display='flex' flexDirection='column' sx={{ direction: 'rtl' }}>
                <Form
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  <InputLabel id='demo-simple-select-label'>
                    {t('screens.SecurityScreen.rate_of_speed')}
                  </InputLabel>
                  <FormField
                    name='speed'
                    placeholder={t('screens.SecurityScreen.Maximum_allowed_speed')}
                  />

                  <SubmitButton fullWidth title={t('screens.SecurityScreen.save')} />
                </Form>
              </Box>
            </DialogContent>
          </Dialog>
        </div>
        {deviceList?.length !== 0 && (
          <Card
            className={speed.overSpeedLimitation === 0 ? 'bgOff' : 'bgOn'}
            sx={{ border: '2px solid' }}
          >
            <Box alignItems='flex-end' display='flex' flexDirection='column'>
              <Box
                sx={{
                  width: '100%',
                  p: '4px',
                  direction: 'rtl',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Typography>{t('screens.SecurityScreen.car')}</Typography>
                <Typography>{deviceList?.properties?.modelName}</Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  p: '4px',
                  direction: 'rtl',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Typography>{t('screens.SecurityScreen.maximum_speed_limit_is_set')}</Typography>
                <Typography> {speed.overSpeedLimitation} کیلومتر</Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  p: '4px',
                  direction: 'rtl',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Typography>{t('screens.SecurityScreen.limitation_status')}</Typography>
                <Typography>{speed.overSpeedLimitation === 0 ? 'غیرفعال' : 'فعال'}</Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  p: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <ToggleButtonGroup
                  aria-label='text alignment'
                  exclusive
                  sx={{ alignSelf: 'center', mt: 1 }}
                  // onChange={handleAlignment}
                  // value={alignment}
                >
                  <ToggleButton
                    aria-label='left aligned'
                    onClick={() => {
                      dispatch(overSpeedAlarms({ deviceId: id }))
                      setOpen3(true)
                    }}
                    sx={{ background: 'transparent', color: '#fff', p: '10px' }}
                    value='left'
                  >
                    <Tooltip title={t('screens.SecurityScreen.view_activity')}>
                      <ShutterSpeedIcon />
                    </Tooltip>
                  </ToggleButton>
                  <ToggleButton
                    aria-label='centered'
                    // eslint-disable-next-line no-unneeded-ternary
                    disabled={speed.overSpeedLimitation === 0 ? true : false}
                    onClick={() => {
                      if (id !== undefined) dispatch(offOverSpeedLimitation({ imei: id, speed: 0 }))
                      setSpeed({ overSpeedLimitation: 0 })
                    }}
                    sx={{ background: 'transparent', color: '#fff', p: '10px' }}
                    value='center'
                  >
                    <Tooltip title={t('screens.SecurityScreen.Disable_restrictions')}>
                      <WifiTetheringOffIcon />
                    </Tooltip>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Box>
          </Card>
        )}
        <div>
          <Dialog
            aria-describedby='alert-dialog-description'
            aria-labelledby='alert-dialog-title'
            // onClose={handleCancelRectangle}
            open={open3}
            sx={{ maxHeight: 600 }}
          >
            <DialogTitle id='alert-dialog-title'>
              {t('screens.SecurityScreen.activity')}
            </DialogTitle>
            <DialogContent>
              <Box
                display='flex'
                flexDirection='column'
                sx={{ direction: 'rtl', '& .MuiTableCell-root': { padding: '1px 6px' } }}
              >
                <Paper sx={{ width: '102%', overflow: 'hidden', direction: 'rtl' }}>
                  {rows?.data?.length !== 0 ? (
                    <TableContainer sx={{ maxHeight: 400 }}>
                      <Table aria-label='sticky table' size='small' stickyHeader>
                        <TableHead>
                          <TableRow
                            sx={{
                              '&:last-child td, &:last-child th': { backgroundColor: 'lightgray' },
                            }}
                          >
                            {columns.map((column) => (
                              <TableCell
                                align={column.align}
                                key={column.id}
                                style={{ minWidth: column.minWidth, padding: '0' }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows?.data?.map((row: any, index: number) => {
                            return (
                              <TableRow
                                key={row.id}
                                sx={{ '&:nth-of-type(odd)': { backgroundColor: '#fff' } }}
                                tabIndex={-1}
                              >
                                <TableCell align='center'>{index + 1}</TableCell>
                                <TableCell align='center'>{shamsiDay(row.creationDate)}</TableCell>
                                <TableCell align='center'>{shamsi(row.creationDate)}</TableCell>
                                <TableCell align='center'>{row.runtimeSeconds}</TableCell>
                                <TableCell align='center'>{row.speed}</TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Typography sx={{ p: '14px' }}>اطلاعاتی برای نمایش وجود ندارد</Typography>
                  )}
                </Paper>
                <Button onClick={handleCancelOpen} sx={{ mt: 1 }}>
                  {t('screens.SecurityScreen.cancel')}
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
        </div>
        <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <div className='spinner'></div>
        </Backdrop>
      </Box>
    </Container>
  )
}

export default SecurityScreen
